"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("./Types");
function rgbsToArg(rgbs) {
    if (typeof rgbs === 'string' && rgbs.length > 0) {
        return { rgbs: rgbs };
    }
    else if (Array.isArray(rgbs) && rgbs.length > 0 && typeof rgbs[0] === 'string') {
        return { rgbs: rgbs.join('|') };
    }
    else if (Types_1.isRgbItemList(rgbs)) {
        return { rgbs: rgbs.map(function (_a) {
                var r = _a.r, g = _a.g, b = _a.b;
                return r + "," + g + "," + b;
            }).join('|') };
    }
    else {
        return {};
    }
}
exports.rgbsToArg = rgbsToArg;
function yarnsToArg(yarns) {
    return parseArg('yarns', yarns);
}
exports.yarnsToArg = yarnsToArg;
function parseArg(key, value) {
    if (value && Array.isArray(value) && value.length > 0) {
        return _a = {}, _a[key] = "" + value.join(','), _a;
    }
    else if (typeof value === 'string' && value.length > 0) {
        return _b = {}, _b[key] = "" + value, _b;
    }
    else if (typeof value === 'number' || typeof value === 'boolean') {
        return _c = {}, _c[key] = "" + value, _c;
    }
    else {
        return {};
    }
    var _a, _b, _c;
}
exports.parseArg = parseArg;
